import { createBrowserRouter } from "react-router";

import { routesConfig } from "./routes";

const router = createBrowserRouter(routesConfig);

export default router;
